<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table
			ref="table"
			pagination
			:max-items="itemsPerPage"
			search
			:data="orders"
		>
			<template slot="thead">
				<vs-th sort-key="created_at_date">Date</vs-th>
				<vs-th sort-key="user_uid">User/Coach</vs-th>
				<vs-th sort-key="topic">Topic</vs-th>
				<vs-th sort-key="target">Target</vs-th>
				<vs-th sort-key="price">Price</vs-th>
				<vs-th sort-key="payment">Payed</vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr
						:data="tr"
						:key="indextr"
						v-for="(tr, indextr) in data"
					>
						<vs-td>
							<p class="created-at-date">
								{{ formatDate(tr.created_at_date) }}
							</p>
						</vs-td>

						<vs-td>
							<p class="user-id">
								{{ tr.user_uid }}
							</p>
							<p class="user-id">
								{{ tr.coach_uid }}
							</p>
						</vs-td>

						<vs-td>
							<p class="font-medium truncate">
								{{ tr.topic }}
							</p>
						</vs-td>

						<vs-td>
							<p class="product-category">
								{{ tr.target }}
							</p>
						</vs-td>

						<vs-td>
							<p class="product-price">
								{{ tr.price }}
								{{ tr.currency }}
							</p>
						</vs-td>

						<vs-td>
							<p class="payed-status">
								<vs-checkbox
									disabled="true"
									:checked="isOrderPayed(tr)"
								/>
							</p>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moment from "moment";

export default {
	data() {
		return {
			itemsPerPage: 20,
			isMounted: false,

			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {}
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		orders() {
			return this.$store.getters["orders/allOrdersByDateDesc"];
		},
		queriedItems() {
			return this.$refs.table
				? this.$refs.table.queriedResults.length
				: this.orders.length;
		}
	},
	methods: {
		addNewData() {
			Console.log("addNewData()");
		},
		formatDate(timestamp) {
			if (timestamp != null) {
				let myDate = new Date(timestamp.seconds * 1000);
				//console.log(myDate);
				return moment(myDate).format("DD.MM.YYYY hh:mm");
			} else {
				return "";
			}
		},
		isOrderPayed(order) {
			return order.payment != null;
		}
	},
	created() {
		console.log("orders created"); // I'm text inside the component.
		this.$store.dispatch("orders/openDBChannel");
		//console.log("Values:");
		//console.log(this.$store.state.orders.data);
	},
	mounted() {
		this.isMounted = true;
	},
	destroyed() {
		console.log("orders destroyed"); // I'm text inside the component.
		this.$store.dispatch("orders/closeDBChannel");
	}
};
</script>
